module.exports = __webpack_public_path__ + "img/MTQ.35d25879.svg";